// DO NOT PUT SECRETS IN HERE!!!
const production = {
  flags: {},
  FRONTEND_URL: "https://app.read.ai",
  RECORDINGS_URL: "https://recordings.read.ai",
  RSS_LINKS_URL: "https://cal.read.ai",
  api: {
    HOST: "https://api.read.ai",
    disableMetricsQueries: false,
  },
  tracking: {
    // This is a different property than the staging and dev tags
    GOOGLE_ID: "G-2Y1H5ZJMBK",
    MIXPANEL_ID: "68e743b21f2eb5cbbfd12657136457ad",
    LINKED_IN_PARTNER_ID: "4030676",
    MIXPANEL_VERBOSE_LOG: true,
    STATSIG_KEY: "client-vhlWCCvJDjpmInAZCqISwTa4KwHvZXy5ZIc1ORbZznl",
  },
  stripe: {
    publishableKey:
      "pk_live_51LB55RKEmPi2JwflhJUwrozvOO93KBlJLsycu8DKRtkg49zqSNJ4SVdyZ7JWqyZyzP0NnEjPFDubp5IAOmUfPTRy00mLipX8mT",
    subscriptionCheckoutReturnUrl:
      "https://api.read.ai/billing/checkout-confirm-return",
    creditCheckoutReturnUrl:
      "https://api.read.ai/billing/credit-checkout-confirm-return",
    setupReturnUrl: "https://api.read.ai/billing/setup-confirm-return",
  },
  apps: {
    teams: {
      AAD_CLIENT_ID: "35e7f5d2-9978-464f-8710-c7a05d5b9fdf",
      APP_ID: "18eb20ae-cd59-48c6-8060-fbe171a917e5",
    },
    meet: {
      CLOUD_PROJECT_NUMBER: "766098389391",
      CLIENT_ID:
        "766098389391-arnnrsjat8leug7ab7e0cdm5a1n58tbc.apps.googleusercontent.com",
    },
  },
  billing: {
    prices: {
      // prices are monthly for a single seat
      byPriceId: {
        // updated prices
        price_1NuLiAKEmPi2JwflzVnvkZTv: 39.75, // monthly enterprise+
        price_1NwtGFKEmPi2Jwfl1X7FAsCB: 29.75, // annual enterprise+
        price_1Na66kKEmPi2JwflFk5Y1Ig5: 29.75, // monthly enterprise
        price_1Na66NKEmPi2JwflntMUYCZc: 22.5, // annual enterprise
        price_1Na68vKEmPi2JwflRtLVHvEt: 19.75, // monthly pro
        price_1Na684KEmPi2JwflY3PcjCr2: 15, // annual pro
        // legacy prices (do not remove a price from here unless there are 0 active subscriptions with these price ids!)
        price_1MBkenKEmPi2JwfltJiOlSjp: 25, // monthly enterprise
        price_1MBkenKEmPi2JwflhJLtpkDa: 16.5, // annual enterprise
        price_1MBkeUKEmPi2JwflzB2JkSfc: 10, // annual pro
        price_1MBkeUKEmPi2JwfluRtNLxLt: 15, // monthly pro
      } as Record<string, number | undefined>,
    },
    promotions: {
      trial_extension_on_purchase: "7B46E78ED296A78EC4FFF50E5",
    },
  },
  statusMessage: {
    enabled: [],
  },
  recaptchaSite: "6LdqJfEpAAAAAMNiDreniXk3YObAHS8SLz7snQTz",
};

export type Config = typeof production;
export default production;
